import React, { useState } from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import {
  Container,
  Navbar,
  Nav,
  Button,
  Badge,
  Dropdown,
  Image,
} from "react-bootstrap";
import {
  Menu,
  ShoppingCart,
  User,
  LogOut,
  Users,
  Package,
  CreditCard,
  Settings,
  MapPin,
  Lock,
  Percent,
} from "react-feather";

import { useAuth } from "../contexts/authContext";
import { useCart } from "../contexts/cartContext"; // Import useCart
import { cartSession } from "../utils/cart";

import logo from "../logo.png";
import sheenlacLogo from "../resources/img/sheenlac.png";

const PrivateLayout = () => {
  const { user, logout } = useAuth();
  const { cartCount } = useCart(); // Use the CartContext
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleLogout = async () => {
    await logout();
    cartSession.clear();
    navigate("/login");
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="private-layout">
      <Navbar fixed="top" bg="light" className="header border-bottom">
        <Container fluid>
          <Button variant="light" onClick={toggleSidebar} className="me-2">
            <Menu size={20} />
          </Button>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <Image
              src={sheenlacLogo}
              alt="Sheenlac"
              fluid
              style={{ width: "clamp(100px, 15vw, 150px)" }}
              className="me-2 me-md-3"
            />
            <Image
              src={logo}
              alt={process.env.REACT_APP_PORTAL}
              fluid
              style={{ width: "clamp(150px, 20vw, 200px)" }}
              className=""
            />
          </Navbar.Brand>
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/">
              Shop Now
            </Nav.Link>
            <Nav.Link as={Link} to="/cart" className="position-relative me-3">
              <ShoppingCart size={20} />
              {/* {cartCount > 0 && ( */}
              <Badge
                pill
                bg="danger"
                className="position-absolute start-100 translate-middle cart-quantity"
              >
                {cartCount}
              </Badge>
              {/* )} */}
            </Nav.Link>
            <Dropdown align="end">
              <Dropdown.Toggle className="bg-transparent border-0">
                <div className="d-inline-block p-0 rounded-circle bg-primary user-profile">
                  <User size={18} />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="shadow border-0 fs-medium">
                <div className="p-2 text-center">
                  <div className="fw-medium text-dark-emphasis">
                    Hi {user?.firstName}
                  </div>
                  <Badge bg="secondary" className="text-uppercase">
                    {user?.role === "super_admin"
                      ? "Super Admin"
                      : user?.role === "administrator"
                      ? "Administrator"
                      : "Customer"}
                  </Badge>
                </div>
                <Dropdown.Divider />
                <Dropdown.Item
                  as={Link}
                  to="/profile"
                  className="py-2 text-light-emphasis"
                >
                  <Settings size={16} className="me-2" />
                  Update Profile
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to="/change-password"
                  className="py-2 text-light-emphasis"
                >
                  <Lock size={16} className="me-2" />
                  Change Password
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  onClick={handleLogout}
                  className="py-2 text-light-emphasis"
                >
                  <LogOut size={16} className="me-2" />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Container>
      </Navbar>

      {/* Main Content Area */}
      <div className="main-content">
        <div
          className={`sidebar bg-light border-right ${
            isSidebarCollapsed ? "collapsed" : ""
          }`}
        >
          <Nav className="flex-column">
            {["super_admin", "administrator"].includes(user?.role) && (
              <>
                {/* <Nav.Link as={NavLink} to="/dashboard">
                  <Home size={16} className="align-text-top" />
                  {!isSidebarCollapsed && (
                    <span className="ms-2">Dashboard</span>
                  )}
                </Nav.Link> */}
                <Nav.Link as={NavLink} to="/users">
                  <Users size={16} className="align-text-top" />
                  {!isSidebarCollapsed && <span className="ms-2">Users</span>}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/address">
                  <MapPin size={16} className="align-text-top" />
                  {!isSidebarCollapsed && (
                    <span className="ms-2">Addresses</span>
                  )}
                </Nav.Link>
                {/* <Nav.Link as={NavLink} to="/categories">
                  <List size={16} className="align-text-top" />
                  {!isSidebarCollapsed && (
                    <span className="ms-2">Categories</span>
                  )}
                </Nav.Link> */}
                <Nav.Link as={NavLink} to="/products">
                  <Package size={16} className="align-text-top" />
                  {!isSidebarCollapsed && (
                    <span className="ms-2">Products</span>
                  )}
                </Nav.Link>
                <Nav.Link as={NavLink} to="/discounts">
                  <Percent size={16} className="align-text-top" />
                  {!isSidebarCollapsed && (
                    <span className="ms-2">Discounts</span>
                  )}
                </Nav.Link>
              </>
            )}
            {(user?.role === "super_admin" || user?.role === "customer") && (
              <Nav.Link as={NavLink} to="/transactions">
                <CreditCard size={16} className="align-text-top" />
                {!isSidebarCollapsed && (
                  <span className="ms-2">Transactions</span>
                )}
              </Nav.Link>
            )}
            <Nav.Link as={NavLink} to="/orders">
              <Package size={16} className="align-text-top" />
              {!isSidebarCollapsed && <span className="ms-2">Orders</span>}
            </Nav.Link>
            <Nav.Link as={NavLink} to="/order-cancel-request">
              <Package size={16} className="align-text-top" />
              {!isSidebarCollapsed && (
                <span className="ms-2">Order Cancel Requests</span>
              )}
            </Nav.Link>
          </Nav>
        </div>
        <div
          className={`content-and-footer ${
            isSidebarCollapsed ? "expanded" : ""
          }`}
        >
          <div className="content">
            <Outlet />
          </div>
          <footer className="footer p-3 text-center bg-light border-top">
            <Container>
              <div>
                &copy; {new Date().getFullYear()} Sheenlac. All rights reserved.
              </div>
            </Container>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PrivateLayout;
